export const validateConsulttForm = (formData) => {
  const errors = {};

  // UserName validation
  if (!formData.UserName.trim()) {
    errors.UserName = "User name is required";
  }

  // ContactNumber validation
  if (!formData.ContactNumber || formData.ContactNumber.trim().length < 1) {
    errors.ContactNumber = "Contact number is required.";
  } else if (!/^\d{1,15}$/.test(formData.ContactNumber)) {
    errors.ContactNumber =
      "Contact number must be a valid numeric value with up to 15 digits.";
  }

  // EmailAddress validation
  if (!formData.EmailAddress.trim()) {
    errors.EmailAddress = "Email is required";
  } else if (
    !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.EmailAddress)
  ) {
    errors.EmailAddress = "Enter a valid email address";
  }

  // WorkAvailability validation
  if (!formData.Categories || formData.Categories.length === 0) {
    errors.Categories = "Categories is required";
  }

  // Locality validation

  if (!formData.Budget || formData.Budget.trim() === "") {
    errors.Budget = "Budget is required";
  }
  if (!formData.LookingFor || formData.LookingFor.trim() === "") {
    errors.LookingFor = "LookingFor is required";
  }
  if (!formData.OnSiteVisit || formData.OnSiteVisit.trim() === "") {
    errors.OnSiteVisit = "OnSiteVisit is required";
  }
  if (!formData.CompareVendor || formData.CompareVendor.trim() === "") {
    errors.CompareVendor = "CompareVendor is required";
  }
  if (!formData.ContactMedium || formData.ContactMedium.trim() === "") {
    errors.ContactMedium = "ContactMedium is required";
  }
  if (!formData.RequirementDetail || formData.RequirementDetail.trim() === "") {
    errors.RequirementDetail = "RequirementDetail is required";
  }

  return errors;
};
